module.exports = __webpack_public_path__ + "img/bg_welfare.d4d68fcf.jpg";